import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const EditSparePercent = () => {
  const { id } = useParams(); // Get vehicle type ID from URL
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fld_rate: "" });
  const canEdit = hasPermission("Hire vehicle Spare percentage", "edit");
  

  // Fetch vehicle type when the component mounts
  useEffect(() => {
  const fetchVehicleType = async () => {
    try {

      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/get_edit_spare_percent/${id}`
      );

      const apiDate = response.data.fld_date;
      const formattedDate = apiDate ? new Date(apiDate).toISOString().split("T")[0] : "";

      setFormData({
        fld_rate: response.data.fld_rate,
        fld_date: formattedDate,
      });
    } catch (error) {
      console.error("Error fetching vehicle type:", error);
    }
  };

  fetchVehicleType();
}, [id]);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      Swal.fire({
                                title: "Submitting...",
                                text: "Please wait while we process your request.",
                                allowOutsideClick: false,
                                didOpen: () => {
                                    Swal.showLoading();
                                },
                            });
      await axios.put(
        `https://rfs2.infraconsoft.net.in/api/edit_spare_percent_api/${id}`,
        formData
      );

        Swal.fire("Success", "Spares Percentage Updated Successfully", "success");

      // Reset form
      setFormData({ fld_type: "" });

      // Navigate after a slight delay
      navigate("/vehicle_sparspercentagemaster_listing");
      
    } catch (error) {
      console.error("Error updating details:", error);
      alert("Failed to update record");
    }
  };


  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Edit Spare Percent</h2>
                    <Link to='/vehicle_sparspercentagemaster_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Date:</label>
              <input
  type="text"
  name="fld_date"
  value={
    formData.fld_date
      ? new Date(formData.fld_date).toLocaleDateString("en-GB") // DD/MM/YYYY
      : ""
  }
  readOnly
/>


              </div>
              <div className="form-group">
                <label>Spare Percent:</label>
                <input
                  type="text"
                  name="fld_rate"
                  value={formData.fld_rate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditSparePercent;
